import { BarChart3, Users, Building2, CreditCard, Settings, LogOut } from 'lucide-react';
import { cn } from '../../../utils/cn';
import Icon from '../../../components/AppIcon';


const AdminSidebar = ({ activeSection, onSectionChange }) => {
  const menuItems = [
    {
      id: 'analytics',
      label: 'Dashboard',
      icon: BarChart3,
      description: 'Métricas y estadísticas'
    },
    {
      id: 'users',
      label: 'Usuarios',
      icon: Users,
      description: 'Gestión de miembros'
    },
    {
      id: 'businesses',
      label: 'Empresas',
      icon: Building2,
      description: 'Aprobaciones y verificación'
    },
    {
      id: 'payments',
      label: 'Pagos',
      icon: CreditCard,
      description: 'Transacciones y retiros'
    }
  ];

  return (
    <aside className="w-64 bg-card border-r min-h-[calc(100vh-64px)] sticky top-16">
      <div className="p-6">
        <h2 className="text-lg font-bold text-foreground mb-6">
          Panel de Administración
        </h2>

        <nav className="space-y-2">
          {menuItems?.map((item) => {
            const Icon = item?.icon;
            const isActive = activeSection === item?.id;

            return (
              <button
                key={item?.id}
                onClick={() => onSectionChange(item?.id)}
                className={cn(
                  "w-full flex items-start gap-3 p-3 rounded-lg transition-colors text-left",
                  isActive 
                    ? "bg-primary text-primary-foreground" 
                    : "hover:bg-muted text-foreground"
                )}
              >
                <Icon className={cn(
                  "w-5 h-5 mt-0.5 flex-shrink-0",
                  isActive ? "text-primary-foreground" : "text-muted-foreground"
                )} />
                <div>
                  <p className={cn(
                    "font-medium text-sm",
                    isActive ? "text-primary-foreground" : "text-foreground"
                  )}>
                    {item?.label}
                  </p>
                  <p className={cn(
                    "text-xs mt-0.5",
                    isActive ? "text-primary-foreground/80" : "text-muted-foreground"
                  )}>
                    {item?.description}
                  </p>
                </div>
              </button>
            );
          })}
        </nav>

        <div className="mt-8 pt-6 border-t space-y-2">
          <button className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-muted text-foreground transition-colors text-left">
            <Settings className="w-5 h-5 text-muted-foreground" />
            <span className="text-sm font-medium">Configuración</span>
          </button>
          <button className="w-full flex items-center gap-3 p-3 rounded-lg hover:bg-red-50 text-red-600 transition-colors text-left">
            <LogOut className="w-5 h-5" />
            <span className="text-sm font-medium">Cerrar Sesión</span>
          </button>
        </div>
      </div>
    </aside>
  );
};

export default AdminSidebar;